let result;

export const getStickyVideo = () => {
  if (result) return Promise.resolve(result);
  return import('./sticky-video').then((module) => {
    result = module;
    return module;
  });
};